import type { JSX } from "react";

import { Stack } from "@mantine/core";

import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { DetectedCues } from "@/sales-tools/detected-cues/DetectedCues";

import { CustomerLocation } from "./CustomerLocation";
import { DigitalCompetency } from "./digital-competency/DigitalCompetency";

export function CustomerInsights(): JSX.Element | null {
    const { isDigitalCompetencyInsightEnabled } = usePartnerFeatureConfigured();
    return (
        <Stack p="sm" pt="sm" gap="sm">
            <CustomerLocation />
            <DetectedCues />
            {isDigitalCompetencyInsightEnabled && <DigitalCompetency />}
        </Stack>
    );
}
